import { DrEntity } from './dr-entity';
import { GroupFieldDefinition } from './group-field';

export class ExportMetadataProfileEntry extends DrEntity {

    static maxNameLength = 255;

    dbFieldType: null;
    digitalReefMetadataValue: string;
    emType: string;
    enabled: boolean;
    externalName: string;
    includeInContentIndex: boolean;
    required: boolean;
    tagFieldDefinition: null;
    groupFieldDefinition: GroupFieldDefinition;
    metadataTooltip = undefined;
    customFieldEntryId: number;

    constructor(value?: Partial<ExportMetadataProfileEntry>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
    }
}
